<template>
  <el-dialog class="sumsub_box" :visible="value" @close="handleCancel">
    <div id="sumsub-websdk-container"></div>
  </el-dialog>
</template>

<script>
import { apiGetVerificationToken } from '@/resource';
import sumsub from '@sumsub/websdk';
import { I18N_PLATFORM_MAP } from '@/constants/language';

export default {
  name: 'SumsubSecurity',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sumsubType: {
      type: Number,
      default: 3
    },
    sumsubVerifyNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      snsWebSdkInstance: null
    };
  },
  watch: {
    value(bool) {
      if (bool) {
        this.initializeSumsub();
      } else {
        this.destroySumsubInstance();
      }
    },

    lang() {
      return this.$store.state.common.lang;
    }
  },
  computed: {
    sumsubLang() {
      switch (this.lang) {
        case 'zh_CN':
          return 'zh';
        case 'zh_TW':
          return 'zh-tw';
        default:
          return I18N_PLATFORM_MAP[this.lang] || 'en';
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('input', false);
      this.destroySumsubInstance(); // 关闭弹框时销毁 SDK 实例
    },
    createAccessToken() {
      return apiGetVerificationToken(this.sumsubType);
    },
    async initializeSumsub() {
      const accessToken = await apiGetVerificationToken(this.sumsubType);
      this.snsWebSdkInstance = sumsub
        .init(accessToken.data.data, this.createAccessToken)
        .withConf({
          lang: this.sumsubLang
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        .on('idCheck.onApplicantActionStatusChanged', payload => {
          console.log('-----onApplicantActionStatusChanged------:', payload);
          if (this.sumsubVerifyNum >= 3 && payload.reviewResult.reviewAnswer === 'RED') {
            this.handleCancel();
            this.$emit('onFailedSumsub');
          }
          if (payload.reviewResult?.reviewAnswer === 'GREEN') {
            this.$store.commit('common/setHasVerify2FA', true);
            this.$emit('onSuccess');
          }
        })
        .build();
      this.snsWebSdkInstance.launch('#sumsub-websdk-container');
    },
    destroySumsubInstance() {
      if (this.snsWebSdkInstance) {
        this.snsWebSdkInstance.destroy(); // 销毁 SDK 实例
        this.snsWebSdkInstance = null; // 清空引用
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sumsub_box {
  min-height: 200px;
}
</style>
